import './index.scss';

export default function Footer() {
  return (
    <p className='footer'>
      {/* <span className='logo'>HHO</span> */}
      <span className='copyright'>© 2021-现在 HHO , all rights reserved 两氢一氧（杭州）数字科技有限公司</span>
    </p>
  );
}